import * as Api from "./request.js";
let httpRequest = Api.default.httpRequest;

export default {
  // 获取当前待打印发票号
  // getCurrentPrintNumber(params) {
  //   return httpRequest({
  //     url: `/win/electricity/billMgr/currentTicket`, //新接口
  //     params,
  //     method: "GET"
  //   });
  // },
  // 获取电费收取统计信息
  getElectricityStatistics() {
    return httpRequest({
      url: `/win/electricity/charge/orderStatistics`, //新接口
      method: "POST"
    });
  },
  // 获取水费收取统计信息
  getWaterStatistics() {
    return httpRequest({
      url: `/win/waterBill/orderStatistics`, //新接口
      method: "POST"
    });
  },
  // 电费收取-用户模糊查询
  userSearch(params) {
    return httpRequest({
      url: `/win/electricity/charge/listUserByParam`,
      params,
      method: "GET"
    });
  },

  // 电费收取-根据用户主键获取用户所有欠费账单
  getArrearsBillList(userId) {
    return httpRequest({
      url: `/win/electricity/charge/listArrearsBillByUserId/${userId}`,
      method: "GET"
    });
  },

  // 电费收取-根据抄表信息主键集合获取明细
  getArrearsDetailList(readerInfoIds) {
    return httpRequest({
      url: `/win/electricity/charge/listArrearsDetailByReaderInfoIds?readerInfoIds=${readerInfoIds}`,
      method: "GET"
    });
  },

  // 电费收取-创建订单
  createElectricityBills(data) {
    return httpRequest({
      url: `/order/createOrder`,
      data,
      method: "POST"
    });
  },
  // 电费收取-创建支付信息
  createElectricityPayInfo(data) {
    return httpRequest({
      url: `/order/createPayInfo`,
      data,
      method: "POST"
    });
  },

  // 电费收取-撤销欠费
  revokeArrearsLists(data) {
    return httpRequest({
      url: `/win/electricity/charge/revokeArrears`,
      data,
      method: "POST"
    });
  },
  // 区域列表 参数区域类型(1=机械电表区域,2=机械水表区域,3=卡表区域)
  queryAreaList(data) {
    return httpRequest({
      url: `/area/queryAreaList/${data}`,
      method: "GET"
    });
  },
  // 获取支付方式枚举列表
  getPayChannelEnumList() {
    return httpRequest({
      // url: `/enum/getPayChannelEnumList`,
      url: `/enum/getWinPayChannelEnumList`, //新接口
      method: "GET"
    });
  },
  // 水收费查询
  queryOrderList(data) {
    return httpRequest({
      url: `/win/waterBill/queryOrderList`,
      data,
      method: "POST"
    });
  },
  // 窗口水表用户档案列表
  queryWaterUserList(data) {
    return httpRequest({
      url: `/win/waterUser/queryWaterUserList`,
      data,
      method: "POST"
    });
  },
  // 窗口水表用户档案详情
  queryWaterBillList(data) {
    return httpRequest({
      url: `/win/waterBill/queryWaterBillList/${data}`,
      method: "GET"
    });
  },
  // 列表分页查询(包含统计信息)
  pageOrderByParam(params) {
    return httpRequest({
      url: `/win/water/billMgr/pageOrderByParam`,
      data: params,
      method: "POST"
    });
  },
  // 电费票据管理-分页查询
  getElectricityTickets(params) {
    return httpRequest({
      url: `/win/electricity/billMgr/pageOrderByParam`,
      data: params,
      method: "POST"
    });
  },

  // 电费票据管理-票号管理
  // electricityTicketsManage(data) {
  //   return httpRequest({
  //     url: `/win/electricity/billMgr/ticketNumSet`,
  //     data,
  //     method: "POST"
  //   });
  // },

  // 电费票据管理-批量打印
  // electricityTicketsPrint(data) {
  //   return httpRequest({
  //     url: `/win/electricity/billMgr/batchPrint`,
  //     data,
  //     method: "POST"
  //   });
  // },

  // 电费票据管理-数据有误
  electricityDataError(data) {
    return httpRequest({
      url: `/win/electricity/billMgr/dataError`,
      data,
      method: "POST"
    });
  },
  // 电费票据管理-票号重置
  // electricityTicketReset(data) {
  //   return httpRequest({
  //     url: `/win/electricity/billMgr/restTicketNum`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 卡表-票号重置
  // cardTicketReset(data) {
  //   return httpRequest({
  //     url: `/water/card/orderMgr/restTicketNum`,
  //     data,
  //     method: "POST"
  //   });
  // },

  // 电费收费查询-支付方式集合
  getPayTypes() {
    return httpRequest({
      url: `/enum/getWinPayChannelEnumList`,
      method: "GET"
    });
  },
  // 电费收费查询-页面信息
  getChargeSearch(data) {
    return httpRequest({
      url: `/win/electricity/billMgr/pageCharge`, //新接口
      data,
      method: "POST"
    });
  },
  // 窗口端_登录
  loginWin(data) {
    return httpRequest({
      url: `/login/loginWin`,
      data,
      method: "POST"
    });
  },
  // 窗口修改密码-未登录
  updateWinPwd(data) {
    return httpRequest({
      url: `/login/updateWinPwd`,
      data,
      method: "POST"
    });
  },
  // 窗口退出登录
  logoutWin(params) {
    return httpRequest({
      url: `/login/logoutWin`,
      params,
      method: "GET"
    });
  },
  // 用户管理-分页查询
  pageUserByParam(params) {
    return httpRequest({
      url: `/water/card/user/pageUserByParam`,
      params,
      method: "GET"
    });
  },
  // 用户管理-获取用水性质列表
  listNature() {
    return httpRequest({
      url: `/water/card/nature/listNature`,
      method: "GET"
    });
  },
  // 用户管理-根据IC卡号获取用户信息
  getUserByIcNo(userIcNo) {
    return httpRequest({
      url: `/water/card/user/getUserByIcNo/${userIcNo}`,
      method: "GET"
    });
  },
  // 批量打印
  // batchPrint(data) {
  //   return httpRequest({
  //     url: `/win/water/billMgr/batchPrint`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 用户管理-修改
  editUser(data) {
    return httpRequest({
      url: `/water/card/user/editUser`,
      data,
      method: "POST"
    });
  },
  // 用户管理-补卡
  replaceCard(data) {
    return httpRequest({
      url: `/water/card/user/replaceCard`,
      data,
      method: "POST"
    });
  },
  // 用户管理-补卡记录
  pageReplaceCardRecordByUserId(data) {
    return httpRequest({
      url: `/water/card/user/pageReplaceCardRecordByUserId`,
      data,
      method: "POST"
    });
  },
  // IC卡充值-获取充值记录 充值类型(0=开卡充值,1=正常充值,2=补充),default=1
  // rechargeType 换表充值null 2是充值修改 1：正常
  listRechargeRecord(data) {
    return httpRequest({
      url: `/water/card/rechargeRecord/listRechargeRecord`,
      data,
      method: "POST"
    });
  },
  // IC卡充值-充值
  recharge(data) {
    return httpRequest({
      url: `/water/card/rechargeRecord/recharge`,
      data,
      method: "POST"
    });
  },
  // IC卡充值-充值修改
  editRecharge(data) {
    return httpRequest({
      url: `/water/card/rechargeRecord/editRecharge`,
      data,
      method: "POST"
    });
  },
  // 水表换表-换表
  replaceWater(data) {
    return httpRequest({
      url: `/water/card/user/replaceWater`,
      data,
      method: "POST"
    });
  },
  // 用户开卡-开卡
  registerCard(data) {
    return httpRequest({
      url: `/water/card/user/registerCard`,
      data,
      method: "POST"
    });
  },
  // 收费查询(包含统计信息)
  pageOrderByParamIc(params) {
    return httpRequest({
      url: `/water/card/billMgr/pageOrderByParam`,
      params,
      method: "GET"
    });
  },
  // 卡表票据管理 - 票号设置
  // ticketNumSetIc(data) {
  //   return httpRequest({
  //     url: `/water/card/orderMgr/ticketNumSet`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 票号重置
  // restTicketNumIc(data) {
  //   return httpRequest({
  //     url: `/water/card/orderMgr/restTicketNum`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 票号重置水
  // restTicketNumWater(data) {
  //   return httpRequest({
  //     url: `/win/water/billMgr/restTicketNum`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 数据有误
  dataErrorIc(data) {
    return httpRequest({
      url: `/water/card/orderMgr/dataError`,
      data,
      method: "POST"
    });
  },
  // 批量打印
  // batchPrintIc(data) {
  //   return httpRequest({
  //     url: `/water/card/orderMgr/batchPrint`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 水费票据管理 - 票号设置
  // ticketNumSet(data) {
  //   return httpRequest({
  //     url: `/win/water/billMgr/ticketNumSet`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 水费票据管理 - 票号重置
  // restTicketNum(data) {
  //   return httpRequest({
  //     url: `/win/water/billMgr/restTicketNum`,
  //     data,
  //     method: "POST"
  //   });
  // },
  // 数据有误
  dataError(data) {
    return httpRequest({
      url: `/win/water/billMgr/dataError`,
      data,
      method: "POST"
    });
  },
  // C卡充值-修改写卡标识
  updateWriteCard(waterCardRechargeRecordId) {
    return httpRequest({
      url: `/water/card/rechargeRecord/updateWriteCard/${waterCardRechargeRecordId}`,
      method: "GET"
    });
  },
  // 获取当前最新卡号
  getIcNo() {
    return httpRequest({
      url: `/water/card/user/getIcNo`,
      method: "GET"
    });
  },
  // 卡表票库管理-分页查询
  getIcBill(params) {
    return httpRequest({
      url: `/water/card/orderMgr/pageOrderByParam`,
      params,
      method: "GET"
    });
  },

  /**
   * 2023-02-20 Emily 修改
   * **/

  // 票号设置(修改)
  ticketNumSet(data) {
    return httpRequest({
      url: `/win/ticketNoManager/ticketNumSet`,
      data,
      method: "POST"
    });
  },
  // 票号重置(修改)
  restTicketNum(data) {
    return httpRequest({
      url: `/win/ticketNoManager/restTicketNum`,
      data,
      method: "POST"
    });
  },
  // 批量打印(修改)
  batchPrint(data) {
    return httpRequest({
      url: `/win/ticketNoManager/batchPrint`,
      data,
      method: "POST"
    });
  },
  // 获取当前待打印发票号(修改)
  getCurrentPrintNumber(data) {
    return httpRequest({
      url: `/win/ticketNoManager/currentTicket`, //新接口
      data,
      method: "POST"
    });
  },
  // 获取废票统计
  getInvalidTicket(data) {
    return httpRequest({
      url: `/win/ticketNoManager/invalidTicket`,
      data,
      method: "POST"
    });
  },
  // 发票作废
  ticketVoided(data) {
    return httpRequest({
      url: `/win/ticketNoManager/ticketVoided`,
      data,
      method: "POST"
    });
  },
  // 费用收错
  ticketErrorCharge(data) {
    return httpRequest({
      url: `/win/ticketNoManager/errorCharge`,
      data,
      method: "POST"
    });
  },
  // 回收查询水
  getLastMonthBillWater(data) {
    return httpRequest({
      url: `/win/waterBill/getLastMonthBill`,
      data,
      method: "POST"
    });
  },
  // 回收查询电
  getLastMonthBillElectricity(data) {
    return httpRequest({
      url: `/win/electricity/charge/getLastMonthBill`,
      data,
      method: "POST"
    });
  },
  // 修改打印状态
  updateBatchPrintStatus(data) {
    return httpRequest({
      url: `/win/ticketNoManager/batchPrintStatus`,
      data,
      method: "POST"
    });
  },
  // 账单发票号修改
  modifyBillTicketNo(data) {
    return httpRequest({
      url: `/win/ticketNoManager/modifyBillTicketNo`,
      data,
      method: "POST"
    });
  },
  // 查询同期票号列表
  queryBillTicketNo(data) {
    return httpRequest({
      url: `/win/ticketNoManager/queryBillTicketNo`,
      data,
      method: "POST"
    });
  },

  //垃圾收费查询
  wastePageOrderByParam(params) {
    return httpRequest({
      url: `/water/waste/pageOrderByParam`,
      params,
      method: "GET"
    });
  },
  //根据用户主键获取用户所有垃圾处理费欠费账单
  wasteBylistArrearsBillByUserId(userId) {
    return httpRequest({
      url: `/water/waste/listArrearsBillByUserId/${userId}`,
      method: "GET"
    });
  },
  //数据有误接口
  wasteDataError(data) {
    return httpRequest({
      url: `/water/waste/dataError`,
      data,
      method: "POST"
    });
  },
  //获取垃圾收费统计信息
  getWasteStatistics() {
    return httpRequest({
      url: "/water/waste/orderStatistics",
      method: "POST"
    });
  },
  //获取垃圾处理 用户性质
  getWasteList() {
    return httpRequest({
      url: "/water/card/user/getWasteList",
      method: "GET"
    });
  },
  //获取收费员集合
  getTollmans() {
    return httpRequest({
      url: "/login/getTollmans",
      method: "GET"
    });
  },
  //IC卡充值-充值检查返回垃圾处理费数据
  rechargeCheck(data) {
    return httpRequest({
      url: "/water/card/rechargeRecord/rechargeCheck",
      data,
      method: "POST"
    });
  },
  //获取redis信息
  getWebListDictData(data) {
    return httpRequest({
      url: "/enum/getWebListDictData?code=redis_app_secret",
      data,
      method: "get"
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/api.js
// module id = null
// module chunks = 